import type { QueryClient } from '@w/react-query'

/** Adoption request errors that arrive after navigation, keyed by adopted page id (flashcards-lexicon.spec.md:501-504: shown inline).
 * Same shape as workspace sync status (spaces-resources.ts:80,127-140): a per-ctx Map read through a query, published by invalidation. */
export function createAdoptBumpErrors(queryClient: QueryClient) {
  const errors = new Map<string, unknown>()
  function options(pageId: string) {
    return { queryKey: ['lexicon-adopt-bump-error', pageId], staleTime: Infinity, queryFn: () => Promise.resolve({ error: errors.get(pageId) }) }
  }
  return {
    options,
    report(pageId: string, error: unknown) {
      errors.set(pageId, error)
      return queryClient.invalidateQueries({ queryKey: options(pageId).queryKey })
    },
  }
}
